import { useEffect } from 'react';
import { toast } from 'react-toastify';

export interface FolderFeedbackMessageFlashProps {
  message: {
    type: 'success' | 'error';
    text: string;
  };
}

/**
 * Create a toast when the message changes.
 *
 * @param message
 * @constructor
 */
export default function FolderFeedbackMessageFlash({
  message,
}: FolderFeedbackMessageFlashProps): null {
  useEffect(() => {
    if (message?.type && message?.text) {
      toast(message.text, { type: message.type, autoClose: 10000 });
    }
  }, [message]);

  return null;
}
